<div class="container" kendoTooltip tooltipClass="tooltip-adjust-right" [ngClass]="{'isSelected': isSelected}">
    <div class="one-line-detail one-line-height-18 meatball-parent">
        <div class="entity-area text-ellipsis" *ngIf="primaryEntityName">
            <span class="one-entity text-ellipsis" [title]="primaryEntityName">{{primaryEntityName}}</span>
        </div>
        <div class="card-meatball" (click)="onMeatBall($event)">
            <smart-icon class="light" name="meatball"></smart-icon>
        </div>
    </div>
    <div class="one-line-detail">
        <div class="primary-name-area">
            <span [title]="task.name">{{task.name}}</span>
        </div>
    </div>
    <div class="field-area"
        *ngIf="fields.length||(task.status!=='ready'&&task.status!=='inprogress'&&task.taskDefinition.type==='approval')">
        <div class="one-field text-font-12" *ngFor="let item of fields" attr.tid="{{item.fieldDefinition.name}}"
            [ngClass]="{'multi-line-field-value': item.fieldDefinition.type==='textArea'}">
            <div class="field-name-area">
                <div class="field-name text-ellipsis" [title]="item.fieldDefinition.name">{{item.fieldDefinition.name}}
                </div>
                <div class="field-name-colon">:</div>
            </div>
            <div class="field-value text-ellipsis"
                *ngIf="item.fieldDefinition.type==='entity' || item.fieldDefinition.type==='user'"
                [title]="getDisplayValueForEntities(item.value)">
                <div *ngIf="item.value && isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <ng-container *ngFor="let linkItem of item.value;let i= index">
                        <a href="{{getEntityRelativeLink(linkItem)}}" target='_blank'>{{linkItem.shortName}}{{i+1
                            === item.value.length?'':';'}}</a>&nbsp;
                    </ng-container>
                </div>
                <div *ngIf="item.value && !isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <a href="{{getEntityRelativeLink(item.value)}}" target='_blank'>{{item.value.shortName}}</a>
                </div>
            </div>
            <kendo-numerictextbox class="field-value" *ngIf="item.fieldDefinition.type==='number'" [value]="item.value"
                [format]="getFormatForNumber(item)" [spinners]="false" [readonly]="true">
            </kendo-numerictextbox>
            <div class="field-value text-ellipsis" *ngIf="item.fieldDefinition.type==='date'"
                [title]="item.value|date:'dd MMM yyyy'">
                {{item.value|date:'dd MMM yyyy'}}
            </div>
            <div class="field-value text-ellipsis" *ngIf="item.fieldDefinition.type==='text'" [title]="item.value">
                {{item.value}}
            </div>
            <div class="multi-line-field-value" *ngIf="item.fieldDefinition.type==='textArea'" [title]="item.value">
                <span>{{item.value}}</span>
            </div>
            <tam-file-info class="file-field-value" *ngIf="item.fieldDefinition.type==='file'" [config]="item.value"
                [isDefaultToPreview]="true">
            </tam-file-info>
            <div class="field-value text-ellipsis" *ngIf="item.fieldDefinition.type==='checkList'"
                [title]="getCheckListFieldInfo(item, checkLists)">
                {{getCheckListFieldInfo(item, checkLists)}}
            </div>
        </div>
    </div>
    <div class="one-line-detail one-line-height-24">
        <div class="task-assignee">
            <div class="one-assignee" *ngFor="let item of getAssignee();index as j"
                [style.background-color]="getBackgroundColorById(item.id)" [style.z-index]="getZIndex(j)">
                {{getAbbrName(item)}}
            </div>
            <div *ngIf="hasMoreAssignee()" class="one-assignee" [style.background-color]="'#48A651'"
                [style.z-index]="0">
                +{{assigneeCount-9}}
            </div>
        </div>
        <div *ngIf="task.taskDefinition.type!=='approval'">
            <div *ngIf="task.status==='ready'" class="task-status task-todo text-12">{{'workflow.task_status_to_do' |
                stringLiterals}}</div>
            <div *ngIf="task.status==='inprogress'" class="task-status task-inprogress text-12">
                {{'workflow.task_status_in_progress' | stringLiterals}}</div>
            <div *ngIf="task.status==='completed'||task.status==='rejected'" class="task-status task-done text-12">
                {{'workflow.task_status_done' | stringLiterals}}
            </div>
        </div>
        <div *ngIf="task.taskDefinition.type==='approval'">
            <div class="task-status text-12"
                [ngClass]="{'task-todo': task.status==='ready', 'task-approve': task.status==='completed', 'task-rejected': task.status==='rejected'}">
                {{displayApproveTaskStatus}}</div>
        </div>
    </div>
    <div class="one-line-detail one-line-height-15" *ngIf="isBottomLineVisible()">
        <div class="card-extra">
            <smart-icon *ngIf="task.comments.length" class="light" name="comments"></smart-icon>
            <span *ngIf="task.comments.length" class="text-12">{{task.comments.length}}</span>
            <smart-icon *ngIf="task.attachments.length" class="light" name="attachments"></smart-icon>
            <span *ngIf="task.attachments.length" class="text-12">{{task.attachments.length}}</span>
        </div>
        <div class="card-date-area" *ngIf="task.dueDate">
            <smart-icon name="timer"></smart-icon>
            <span class="text-12 card-date">{{task.dueDate|date:'dd MMM yyyy'}}</span>
        </div>
    </div>
</div>